<div class="version-dialog-container">
    <!-- Modern Header -->
    <div class="section-header">
        <mat-icon class="section-icon">celebration</mat-icon>
        <span class="section-title">{{ 'ai.releaseNotes' | transloco }}</span>
        <span class="version-info">{{ 'ai.version' | transloco }}: {{ appVersion }}</span>
        <button mat-icon-button class="close-button" (click)="dialogRef.close()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- Release Notes Grid -->
    <div class="release-notes-container">
        <div class="notes-grid">
            <div class="release-card" *ngFor="let item of releaseNotes; let i = index"
                 [style.animation-delay]="i * 0.05 + 's'">
                <div class="card-icon">
                    <mat-icon>auto_awesome</mat-icon>
                </div>
                <div class="card-content">
                    <h3 class="card-title">{{ item.text }}</h3>
                    <p class="card-description">{{ item.description }}</p>
                    <div class="card-footer">
                        <span class="release-date">{{ item.date }}</span>
                        <span class="new-badge">{{ 'ai.new' | transloco }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
